interface ModalElement {
  modalId?: string | number;
  modalTrigger?: string | undefined;
}

export const Modal = (modalElements: NodeListOf<HTMLElement>): void => {
  modalElements.forEach((modal) => {
    const { modalTrigger }: ModalElement = modal.dataset;

    // Trigger (může jich být více)
    if (modalTrigger) {
      const triggerElements: NodeListOf<HTMLElement> = document.querySelectorAll(modalTrigger);
      if (!triggerElements.length) return;

      // Zobrazit modal
      triggerElements.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          modal.style.display = 'block';
        });
      });
    }

    // Zavřít na kliknutí mimo modal
    document.onclick = (event) => {
      if (event.target instanceof Element) {
        const openedModal = event.target as HTMLElement;

        if (openedModal.hasAttribute('data-modal') && openedModal.style.display === 'block') {
          openedModal.style.display = 'none';
        }
      }
    };

    // Tlačítko/a 'Zavřít'
    const buttonsClose: NodeListOf<HTMLElement> = modal.querySelectorAll('[data-modal-close]');
    if (buttonsClose.length) {
      buttonsClose.forEach((buttonClose) => {
        buttonClose.addEventListener('click', () => {
          modal.style.display = 'none';
        });
      });
    }
  });
};

export default Modal;
